import { adminClient as apolloClient } from '@/store/apollo';

import KnowledgeSourceGql from '@/extensions/knowledge-base/store/graphql/queries/KnowledgeSource.gql';

/**
 * The knowledge source of one CMS, counts included.
 *
 * The counts live here and NOT in the CmsBase fragment on purpose: each one is
 * a Qdrant round-trip, eight per CMS, and CmsBase is loaded by FetchSetup for
 * every administered CMS on every app start. An unreachable Qdrant then used up
 * the whole request budget and made it impossible to enter an account at all.
 * The knowledge base settings panel is the only surface that shows them, so it is the
 * only thing that asks for them, when it opens.
 */
export default {
    fetchKnowledgeSource: (cmsId) =>
        new Promise((resolve, reject) => {
            if (!cmsId) {
                reject(new Error('cms_id is required'));
                return;
            }

            apolloClient
                .query({
                    query: KnowledgeSourceGql,
                    variables: { cms_id: parseInt(cmsId) },
                    fetchPolicy: 'network-only',
                })
                .then(({ data }) => resolve(data.EX_AI_KnowledgeSource))
                .catch((err) => reject(err));
        }),
};
